import { render, staticRenderFns } from "./ProductCatalog.vue?vue&type=template&id=c35c0104"
import script from "./ProductCatalog.vue?vue&type=script&lang=js"
export * from "./ProductCatalog.vue?vue&type=script&lang=js"
import style0 from "./ProductCatalog.vue?vue&type=style&index=0&id=c35c0104&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports